<template>
    <div>
        <apex-chart
            v-if="waterData.length"
            type="line"
            :height="350"
            :options="chartOptions"
            :series="series"
        />
        <div v-else class="text-center">Không có dữ liệu</div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState({
            waterData: (state) => state.analyze.waterData,
            listStations: (state) => state.station.items
        }),
        series() {
            let listData = [];
            for (let i = 0; i < this.waterData.length; i++) {
                let exitedData = this.getExitedWaterDataIn(listData, this.waterData[i]);
                if (exitedData)
                    exitedData.data.push(this.convertWaterValue(this.waterData[i].value));
                else
                    listData.push({
                        name: this.waterData[i].stationCode,
                        data: [this.convertWaterValue(this.waterData[i].value)]
                    });
            }
            listData.forEach((item) => {
                item.name = this.mapStationName(item.name);
            });
            return listData;
        },
        chartOptions() {
            let chartOptions = {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                grid: {
                    show: false,
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%',
                        distributed: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    curve: 'straight'
                },
                xaxis: {
                    categories: [],
                    tooltip: {
                        enabled: false
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        formatter: (value) => {
                            return `${value} m`;
                        }
                    },
                    followCursor: true
                }
            };
            // Mapping xaxis data
            let categories = this.waterData.map((item) => item.date);
            categories = _.uniq(categories).sort(
                (d1, d2) => new Date(d1).getTime() - new Date(d2).getTime()
            );
            chartOptions.xaxis.categories = categories;
            return chartOptions;
        }
    },
    methods: {
        mapStationName(code) {
            let itemFound = this.listStations.find((element) => element.code == code);
            return itemFound
                ? itemFound.name.replace('Trạm đo mực nước', '').replace('xã', '')
                : '';
        },
        getExitedWaterDataIn(listA, el) {
            for (let i = 0; i < listA.length; i++)
                if (listA[i].name == el.stationCode) return listA[i];
            return null;
        },
        convertWaterValue(data) {
            return data ? (data / 100).toFixed(2) : 0;
        }
    }
};
</script>